import { Col, Form, Row } from "react-bootstrap"
import { Entity, EntityType, Pass, Role } from "../data/models.interface"
import EntityPassesSubForm from "./EntityPassesSubForm"
import RoleIdsSubForm from "./EntityRoleIdsSubForm"
import KeycardsSubForm from "./KeycardsSubForm"

interface IEntityForm {
	entity: Entity
	setEntity: (entity: Entity) => void
	touched: EntityTouched
	setTouched: (value: EntityTouched) => void
	validationErrors: EntityErrors
	roles: Role[]
	passes: Pass[]
}
const EntityForm = ({ entity, setEntity, touched, setTouched, validationErrors, roles, passes }: IEntityForm) => {
	return (
		<>
			<Row className="mt-4">
				<Col xs={12} sm={6}>
					<Form.Group className="mb-3" controlId="name">
						<Form.Label>Name</Form.Label>
						<Form.Control
							type="text"
							required
							value={entity.name || ""}
							onChange={(e) => setEntity({ ...entity, name: e.target.value })}
							onBlur={() => setTouched({ ...touched, name: true })}
							isInvalid={touched.name && validationErrors.name != null}
						/>
						<Form.Control.Feedback type="invalid">{validationErrors.name}</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col xs={12} sm={6}>
					<Form.Group className="mb-3" controlId="type">
						<Form.Label>Type</Form.Label>
						<Form.Select
							required
							value={entity.type}
							onChange={(e) => setEntity({ ...entity, type: e.target.value as EntityType })}
							isInvalid={touched.type && validationErrors.type != null}>
							<option value={EntityType.EMPLOYEE}>{EntityType.EMPLOYEE}</option>
							<option value={EntityType.VENDOR}>{EntityType.VENDOR}</option>
							<option value={EntityType.STATIC}>{EntityType.STATIC}</option>
							<option value={EntityType.TEMP}>{EntityType.TEMP}</option>
						</Form.Select>
						<Form.Control.Feedback type="invalid">{validationErrors.type}</Form.Control.Feedback>
					</Form.Group>
				</Col>
			</Row>
			<Row className="mt-4">
				<KeycardsSubForm
					keycards={entity.keycards || []}
					setKeycards={(value) => setEntity({ ...entity, keycards: [...value] })}
				/>
			</Row>
			<Row className="mt-4">
				<RoleIdsSubForm
					roleIds={entity.roleIds || []}
					setRoleIds={(value) => setEntity({ ...entity, roleIds: [...value] })}
					roles={roles}
				/>
			</Row>
			<Row className="mt-4">
				<EntityPassesSubForm
					entityPasses={entity.passes || []}
					setEntityPasses={(value) => setEntity({ ...entity, passes: [...value] })}
					passes={passes}
				/>
			</Row>
		</>
	)
}
export default EntityForm

export interface EntityTouched {
	name?: boolean
	type?: boolean
	keycards?: boolean
	roleIds?: boolean
	passes?: boolean
}
export interface EntityErrors {
	name?: string
	type?: string
	keycards?: string
	roleIds?: string
	passes?: string
}
